import { Popover } from "antd";
import React, { useEffect } from "react";
import { CETActionButtonData } from "../../DynamicData/CETCActionButtonData";
import components from "../../utils/components";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ResendRegistrationLink from "../PartnerManagement/PartnerMenu/ResendRegistrationLink";
import ChangeRM from "../PartnerManagement/PartnerMenu/ChangeRM";
import DeactivatePartner from "../PartnerManagement/PartnerMenu/DeactivatePartner";
import ChangeSignatory from "../PartnerManagement/PartnerMenu/ChangeSignatory";

import { connect } from "react-redux";

function PopoverMenu({
  row,
  actionDataList,
  setPartnerRefresh,
  partnerRefresh,
  callBackAPI,
  ...props
}) {
  const history = useNavigate();

  const [popOpen, setPopOpen] = useState(false);
  const hide = () => {
    setPopOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setPopOpen(newOpen);
  };

  // useEffect(() => {
  //   props
  //     .getChangeSignatoryDetail(
  //       props.access_token,
  //       row?.original?.partnerFirmId
  //     )
  //     .then((res) => {
  //       console.log("verfictondata", res);
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // }, []);
  // // console.log("actionDataList", actionDataList);

  return (
    <div className="actionsDot">
      <Popover
        color={"white"}
        content={
          <div>
            <div>
              {actionDataList.length > 0 &&
                actionDataList.map((item, index) => {
                  // if (item.name === "viewEditDetails") {
                  //   return (
                  //     <p
                  //       style={{
                  //         cursor: "pointer",
                  //         color: "#00b1b1",
                  //       }}
                  //       onClick={() => {
                  //         history(
                  //           `/CETDashboard/edit-partner/${row.original.applicationId}`
                  //         );
                  //       }}
                  //       key={index}
                  //     >
                  //       {item.actionName}
                  //     </p>
                  //   );
                  // } else {
                  return components(
                    item,
                    hide,
                    index,
                    row,
                    setPartnerRefresh,
                    partnerRefresh,
                    callBackAPI
                  );
                  // }
                })}
            </div>
          </div>
        }
        placement="bottomLeft"
        trigger="click"
        open={popOpen}
        onOpenChange={handleOpenChange}
      >
        ...
      </Popover>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    changeSignatoryData: state.changeSignatoryData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PopoverMenu);
